<!-----------------------------------------------------------------------------
  Copyright (c) 2016 - 2021.                                                  -
  Yega Yazilim ve Bilisim Hizmetleri Dis Tic Ltd Sti (Yega Yazilim)           -
  All Rights Reserved.                                                        -
                                                                              -
  The software and data contained herein are confidential and proprietary     -
  information of Yega Yazilim ("Confidential Information").                   -
                                                                              -
  Users of this software may not disclose such Confidential Information and   -
  shall use it only in accordance with the terms of the license agreement     -
  they entered into with Yega Yazilim.                                        -
                                                                              -
  Author:  Ahmet Dogramaci                                                    -
  Date:    2021-04-06                                                         -
  ----------------------------------------------------------------------------->

<template>
  <div>
    <b-card no-body no-header v-show="isShown">
      <b-card-header>
        <slot name="header" v-bind:item="item"></slot>
      </b-card-header>
      <b-card-body :class="cardBodyClasses" v-if="hasCardBody">
        <slot name="body" v-bind:item="item"></slot>
      </b-card-body>
      <slot name="nobody" v-bind:item="item"></slot>
      <b-card-footer v-if="hasCardFooter">
        <slot name="footer" v-bind:item="item"></slot>
      </b-card-footer>
    </b-card>
    <slot name="data_source"></slot>
    <slot name="dialog"></slot>
  </div>
</template>

<script>
export default {
  name: "yega1-card-form",
  provide(){
    return{
      setItem: this.setItem,
      registerDataSource:this.registerDataSource,
      registerDialog: this.registerDialog,
      editItem: this.editItem,
      handleItemSaved: this.handleItemSaved,
      handleItemUpdated: this.handleItemUpdated,
      handleItemDestroyed: this.handleItemDestroyed
    };
  },
  props:{
    cardBodyClasses:{
      type:String,
      default:''
    },
    isShown:{
      type: Boolean,
      default:true
    },
    hasCardBody:{
      type: Boolean,
      default: true
    },
    hasCardFooter:{
      type: Boolean,
      default: false
    }
  },
  data(){
    return {
      item:{},
      item_data_source: null,
      dialog: null
    };
  },
  methods:{
    setItem(item){
      this.item = item;
    },
    registerDataSource(data_source){
      this.item_data_source = data_source;
    },
    registerDialog(dialog){
      this.dialog= dialog;
    },
    editItem(item){
      this.dialog.loadItem(item.id);
    },
    handleItemUpdated(){
      this.item_data_source.loadItem();
    },
    handleItemSaved(){
      this.item_data_source.loadItem();
    },
    handleItemDestroyed(){
      this.item_data_source.loadItem();
    }
  }
}
</script>

<style scoped>

</style>
